import React from "react";
import ReactDOM from "react-dom/client";
import axios from "axios";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { LocationProvider } from "./Components/LocationContext";
import { attachAuthInterceptors } from "./api/client";
import { publish } from "./utils/swUpdateBus";
import { installGlobalErrorLogging } from "./utils/globalErrorLogging";
import("preline");

// Most page components still call raw `axios.*` directly instead of the
// shared client in src/api/client.js - they share this same default axios
// module, so attaching the 401/tenant-mismatch handling here makes those
// call sites redirect to login too, not just ones using the shared client.
attachAuthInterceptors(axios);
installGlobalErrorLogging(axios);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <LocationProvider>
    <App />
  </LocationProvider>
);
serviceWorker.register({
  // A waiting worker means a new build finished installing. Publish it to
  // the update bus instead of auto-reloading - useAppUpdate.confirmAndReload
  // handles the skipWaiting/controllerchange/reload sequence only after the
  // user confirms, so an open tab is never reloaded out from under the user.
  onUpdate: (registration) => {
    publish({ type: "sw", registration });
  },
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
